import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "axios";
import ActionContext from "context/ActionContext";
import _ from "lodash";
import styled from "styled-components";
import UserService from "services/UserService";
import { getAccountContracts } from "services/ConfigServices";
import ReactLoading from "react-loading";

const TableName = styled.div`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function useActionTable() {
  const [totalRows, setTotalRows] = useState(0);
  const [isRefetched, setIsRefetched] = useState(false);
  const [pending, setPending] = useState(false);
  const appContext2 = useContext(ActionContext);
  const { action, setAction } = appContext2;

  const [structureData, setStructureData] = useState([]);

  const refreshTable = () => {
    setIsRefetched(!isRefetched);
  };

  useEffect(() => {
    getStructureData();
  }, [isRefetched]);

  const getStructureData = async () => {
    setPending(true);
    let data = [];

    await axios
      .get(
        getAccountContracts(
          action.parameters.general.groups[0],
          action.parameters?.impact?.energy
        ),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        data = res.data.contracts;
      });
    setStructureData(data);
    setPending(false);
  };

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <>
        <TableName>Sélection d'un contrat existant</TableName>
      </>
    );
  }, []);

  const loadingComponentMemo = useMemo(() => {
    return (
      <>
        <ReactLoading
          type={"bars"}
          color={"#91c241"}
          height={"60px"}
          width={"60px"}
        />
      </>
    );
  }, []);

  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  return {
    gridState: {
      defaultPageSize: 10,
      data: structureData,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      //title: headerComponentMemo,
      subHeaderComponent: subHeaderComponentMemo,
      progressPending: pending,
      progressComponent: loadingComponentMemo,
    },
    refreshTable,
  };
}
